<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.积分获取方式编辑") }}</span>
    </div>

    <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isEditMode && !isInit">
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont">&#xe618;</i>
              {{ $t("message.修改") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.保存") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isInit">
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont">&#xe667;</i>
              {{ $t("message.刷新") }}
            </el-button>
          </el-link>
        </div>
      </div>
    </div>

    <div class="grid-content subtitle">
      <span>{{ $t("message.积分组信息") }}</span>
    </div>
    <div class="grid-content content-margin">
      <el-divider></el-divider>
      <table class="simpleRow">
        <tr v-if="pointGain.gainid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.积分获取方式ID") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              v-model="pointGain.gainid"
              readonly
              size="mini"
              placeholder=""
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.积分分组") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="pointGain.groupid"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
            >
              <el-option
                v-for="item in pointGroupList"
                :key="item.groupid"
                :label="item.name"
                :value="item.groupid"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.事件类型") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="pointGain.eventtype"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
            >
              <el-option
                v-for="item in eventTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.获取积分") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              v-model="pointGain.point"
              :placeholder="$t('message.请输入')"
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.触发类型") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="pointGain.triggertype"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
              @change="onChangeTriggerType"
            >
              <el-option
                v-for="item in triggerTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr v-if="pointGain.triggertype > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.需触发次数") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              v-model="pointGain.triggerparam"
              :placeholder="$t('message.请输入')"
              type='number'
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.是否有次数限制") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="hasIntervalLimit"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
              @change="onChangeHasIntervalLimit"
            >
              <el-option
                v-for="item in hasIntervalLimitOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr v-if="hasIntervalLimit > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.限制次数") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              v-model="pointGain.intervallimit"
              :placeholder="$t('message.请输入')"
              type='number'

              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr v-if="hasIntervalLimit > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.限制类型") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="pointGain.intervaltype"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
              @change="onChangIntervaltype"
            >
              <el-option
                v-for="item in intervalTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr v-if="hasIntervalLimit > 0 && pointGain.intervaltype > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.限制间隔") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              v-model="pointGain.interval"
              :placeholder="$t('message.请输入')"
              type='number'

              style="width: 175px"
            >
            </el-input>
            <span v-if="pointGain.intervaltype == 1">年</span>
            <span v-if="pointGain.intervaltype == 2">月</span>
            <span v-if="pointGain.intervaltype == 3">周</span>
            <span v-if="pointGain.intervaltype == 4">天</span>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.状态") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="pointGain.state" size="mini">
              <el-radio :label="0">{{ $t("message.正常") }}</el-radio>
              <el-radio :label="1">{{ $t("message.禁用") }}</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.开始日期") }}</span>
          </td>
          <td>
            <el-date-picker
              :disabled="!isEditMode"
              v-model="pointGain.fromdate"
              type="date"
              placeholder="选择日期"
              clearable
              size="mini"
              style="width: 175px"
            >
            </el-date-picker>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.结束日期") }}</span>
          </td>
          <td>
            <el-date-picker
              :disabled="!isEditMode"
              v-model="pointGain.todate"
              type="date"
              placeholder="选择日期"
              clearable
              size="mini"
              style="width: 175px"
            >
            </el-date-picker>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.备注信息") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="pointGain.remarks"
              type="textarea"
              :placeholder="$t('message.请输入')"
              maxlength="1000"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>

        <tr v-if="pointGain.gainid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建日期") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              v-model="pointGain.createdate"
              size="mini"
              placeholder=""
              style="width: 175px"
            />
          </td>
        </tr>
        <tr v-if="pointGain.gainid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建人") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              size="mini"
              v-model="createName"
              style="width: 175px"
            />
          </td>
        </tr>
        <tr v-if="pointGain.gainid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新日期") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              v-model="pointGain.editdate"
              size="mini"
              placeholder=""
              style="width: 175px"
            />
          </td>
        </tr>
        <tr v-if="pointGain.gainid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新人") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              size="mini"
              v-model="editName"
              style="width: 175px"
            />
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import { topfixfunc } from "@/utils/topFix";
import shade from "@/components/shade/shade";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import eventType from "@/utils/EventType";

export default {
  name: "pointGroupDetail",
  components: {
    shade,
  },
  data() {
    return {
      tableHeight: 500,
      eventTypeOptions: [],
      pointGroupList: [],

      triggerTypeOptions: [
        {
          value: 0,
          name: "单次触发获取",
        },
        {
          value: 1,
          name: "连续触发获取",
        },
      ],

      hasIntervalLimit: null,
      hasIntervalLimitOptions: [
        {
          value: 0,
          name: "无次数限制",
        },
        {
          value: 1,
          name: "有次数限制",
        },
      ],

      intervalTypeOptions: [
        { value: 0, name: "永久" },
        { value: 1, name: "按年" },
        { value: 2, name: "按月" },
        { value: 3, name: "按周" },
        { value: 4, name: "按天" },
      ],

      pointGain: {
        appid: 188,
        gainid: 0,
        groupid: null,
        eventtype: null,
        point: null,
        triggertype: null,
        triggerparam: null,
        intervallimit: null,
        intervaltype: null,
        interval: null,
        state: 0,
        fromdate: "",
        todate: "",
        remarks: "",

        createdate: "",
        createid: "",
        editdate: "",
        editid: "",
      },

      createName: "",
      editName: "",

      isEditMode: true,
      isInit: true,
      showResourceStore: false,
    };
  },
  mounted: function () {
    // 用来监听el-main滚动事件
    topfixfunc();
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    goBack() {
      this.$router.go(-1); //返回上一层
    },

    onChangIntervaltype() {
      if (this.intervaltype < 1) {
        this.pointGain.interval = null;
      }
    },

    onChangeHasIntervalLimit() {
      if (this.hasIntervalLimit < 1) {
        this.pointGain.intervallimit = null;
        this.pointGain.intervaltype = null;
        this.pointGain.interval = null;
      }
    },

    onChangeTriggerType() {
      if (this.pointGain.triggertype < 1) {
        this.pointGain.triggerparam = 1;
      }
    },

    doSave() {
      this.isEditMode = false;

      if (this.isInit) {
        rejecthttp(
          true,
          "post",
          "/manage/point/createpointgain",
          this.pointGain,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
            }
          }
        );
      }
      else {
        this.pointGain.editdate = null;
        this.pointGain.editid = null;
        this.pointGain.createdate = null;
        this.pointGain.createid = null;
        rejecthttp(
          true,
          "post",
          "/manage/point/editpointgain",
          this.pointGain,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
            }
          }
        );
      }
    },

    refresh() {
      rejecthttp(
        true,
        "get",
        "/manage/point/pointgrouplist",
        { appid: "188", search: "" },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            // 添加总条数
            this.pointGroupList = doc.data.data;
            this.pointGroupList.forEach((any) => {
              any.editdate = commonUtil.formatDate(any.editdate);
            });
          }
        }
      );

      if (!this.pointGain.gainid) {
        return;
      }
      this.$http
        .get("/manage/point/pointgaindetail", {
          params: {
            appid: this.pointGain.appid,
            gainid: this.pointGain.gainid,
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.pointGain = doc.data.data;
            this.createName = doc.data.exData.datas[0].name;
            this.editName = doc.data.exData.datas[1].name;

            this.pointGain.createdate = commonUtil.formatDate(
              this.pointGain.createdate
            );
            this.pointGain.editdate = commonUtil.formatDate(
              this.pointGain.editdate
            );

            if(this.pointGain.intervallimit > 0) {
              this.hasIntervalLimit = 1;
            } else {
              this.hasIntervalLimit = 0;
            }
          }
        });
    },

    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },

  created() {
    this.pointGain.appid = this.$route.query.appid
      ? this.$route.query.appid
      : 0;
    if (this.$route.query.id) {
      this.pointGain.gainid = this.$route.query.id;
      this.isEditMode = this.$route.query.isEditMode ? true : false;
      this.isInit = false;
    }
    this.eventTypeOptions = eventType.getData();
    this.refresh();
  },

  computed: {},
  // // 隐藏固定栏
  // destroyed () {
  //   var topFix=document.querySelector('.topFix')
  //   // 固定栏隐藏
  //   topFix.style.display='none'
  // }
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointgaindetail.vue